import { Logger } from '~/plugins/log'

const logger = new Logger()
logger.setContext('Flag')

const getDefaultState = () => ({
  activeTags: []
})

export const state = getDefaultState

export const mutations = {
  SET_ALL (state, response) {
    state.activeTags = response.data.active
  }
}

export const getters = {
  isActive: state => tag => (state.activeTags || []).includes(tag)
}

export const actions = {
  async GET_ALL ({ state, rootGetters, commit }, force = false) {
    logger.debug('GET_ALL')

    const { data } = await this.$publicAPI.quietGet('flags/all/')
    commit('SET_ALL', { data })
  }
}